import React from "react";
import { graphql } from "gatsby";
import ObjectLayout from "./../components/ObjectLayout";
import { ObjectBody } from "./../components/ObjectLayout/elements";
import ObjectHeader from "./../components/ObjectHeader";
import ObjectConnections from "./../components/ObjectConnections";
import BlockContent from "./../components/BlockContent";
import TimelineEntryBlock from "./../components/TimelineEntryBlock";
import PdfBlock from "./../components/PdfBlock";
import ImageBlock from "./../components/ImageBlock";
import { StepHeader, StepBody } from "./../components/Step";
import {
  StepWrapper,
  StepComment,
  WalkHeader,
} from "./../components/Step/elements";

// TODO: need to extract the bodies of PDF, Image, TimelineEntry to components

const WalkPage = ({ data, pageContext }) => {
  const { title, description, steps, people, keywords } = data.sanityWalk;
  // console.log(data, pageContext.id);
  // console.log(steps);
  return (
    <ObjectLayout title={`Walk: ${title}`}>
      <ObjectHeader title={title} />
      <ObjectBody>
        <WalkHeader>
          <p className="description">{description}</p>
        </WalkHeader>
        <div>
          {steps.map((step, index) => (
            <StepWrapper key={index}>
              {step._type === "comment" ? (
                <StepComment>
                  <BlockContent blocks={step._rawComment} />
                </StepComment>
              ) : (
                <div>
                  <StepHeader
                    itemData={step.pdf || step.image || step.timelineEntry}
                  />
                  <StepBody
                    body={
                      step._type === "commentTimelineEntry" ? (
                        <TimelineEntryBlock
                          description={step.timelineEntry.description}
                        />
                      ) : step._type === "commentImage" ? (
                        <ImageBlock
                          description={step.image.description}
                          notes={step.image._rawNotes}
                          image={step.image.imageFile.asset.gatsbyImageData}
                          title={step.image.title}
                        />
                      ) : step._type === "commentPdf" ? (
                        <PdfBlock
                          description={step.pdf.description}
                          notes={step.pdf._rawNotes}
                          pdfId={
                            step.pdf.pdfFile &&
                            step.pdf.pdfFile.asset &&
                            step.pdf.pdfFile.asset.assetId
                          }
                          numberOfPages={step.pdf.numberOfPages}
                          title={step.pdf.title}
                        />
                      ) : (
                        JSON.stringify(step)
                      )
                    }
                    comment={<BlockContent blocks={step._rawComment} />}
                  />
                </div>
              )}
            </StepWrapper>
          ))}
        </div>
      </ObjectBody>
      {people.length || keywords.length ? (
        <ObjectConnections people={people} keywords={keywords} />
      ) : null}
    </ObjectLayout>
  );
};

export default WalkPage;

export const pageQuery = graphql`
  query($id: String!) {
    sanityWalk(_id: { eq: $id }) {
      title
      description
      steps {
        ... on SanityComment {
          _type
          _rawComment(resolveReferences: { maxDepth: 10 })
        }
        ... on SanityCommentImage {
          _key
          _type
          _rawComment(resolveReferences: { maxDepth: 10 })
          image {
            _id
            _type
            title
            description
            date
            endDate
            dateApproximateness
            endDateApproximateness
            _rawNotes(resolveReferences: { maxDepth: 10 })
            imageFile {
              asset {
                gatsbyImageData(width: 800)
              }
            }
          }
        }
        ... on SanityCommentTimelineEntry {
          _key
          _type
          _rawComment(resolveReferences: { maxDepth: 10 })
          timelineEntry {
            _id
            _type
            title
            description
            date: startDate
            endDate
            dateApproximateness
            endDateApproximateness
          }
        }
        ... on SanityCommentPdf {
          _key
          _type
          _rawComment(resolveReferences: { maxDepth: 10 })
          pdf {
            _id
            _type
            title
            description
            date
            endDate
            dateApproximateness
            endDateApproximateness
            numberOfPages
            pdfFile {
              asset {
                url
                assetId
              }
            }
            notes {
              _rawChildren
            }
          }
        }
      }
      people {
        _id
        title
      }
      keywords {
        _id
        title
      }
    }
  }
`;
